import styled from "styled-components";

const Container = styled.div(
  (props) => `
    min-width: 30%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: ${props.align || "center"};
    margin: auto;
    background-color: ${props.background || "#fff"};

    @media screen and (max-width: 976px) {
        padding: 1rem;
    }
`
);

const Wrapper = styled.div(
  (props) => `
    display: flex;
    justify-content: ${props.justify};
    align-items: center;
    width: 100%;

    @media screen and (max-width: 976px) {
        padding: 1rem;
        flex-direction: column;
    }
`
);

const SmallContainer = styled.div(
  (props) => `
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: ${props.background};
    height: 255px;
    max-width: 976px;
    margin: auto;

    @media screen and (max-width: 976px) {
        padding: 1rem;
        flex-direction: column;
        justify-content: center;
    }
`
);

const Paragraph = styled.p(
  (props) => `
    font-size: ${props.size || "18px"};
    color: #2B292D;
    text-align: ${props.align || "left"};
`
);

const Title = styled.h1(
  (props) => `
    font-size: ${props.size};
    font-weight: bold;
    color: ${props.color};
    text-align: ${props.align || "left"};
`
);

const Image = styled.img(
  (props) => `
    width: ${props.width};
    height: ${props.height};

    @media screen and (max-width: 976px) {
        max-width: ${props.maxWidth || "200px"};
        height: auto;
    }
`
);

const Button = styled.button(
  (props) => `
    background-color: ${props.primary ? "#FF5E48" : "#fff"};
    color: ${props.primary ? "#fff" : "#FF5E48"};
    border-radius: 0;
    padding: .5rem 1rem;
    font-size: 16px;
    font-weight: bold;
    border: none;
    max-width: 160px;
    margin-right: 1rem;

    @media screen and (max-width: 976px) {
        min-width: ${props.width || "auto"};
        padding: 1rem 0;
        margin: 1rem 0;
    }
`
);

const Input = styled.input`
  min-height: 48px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 0;
  width: 100%;
  font-size: 18px;
  padding: 0 0 0 1rem;
`;

const Textarea = styled.textarea`
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 0;
  width: 100%;
  font-size: 18px;
  padding: 1rem 0 0 1rem;
  height: 168px;
  resize: none;
`;

const Link = styled.a(
  (props) => `
    font-size: ${props.size};
    color: ${props.color};
    text-decoration: none;
    cursor: pointer;

    &:hover {
        font-weight: bold;
    }
`
);

export {
  SmallContainer,
  Paragraph,
  Title,
  Container,
  Image,
  Wrapper,
  Button,
  Input,
  Textarea,
  Link,
};
